import React, { useState, useEffect } from "react";
// import { AgGridColumn, AgGridReact } from "./node_modules/ag-grid-react";
import { PostApi, GetApi } from "../../../js_assets/Network";
import { getParameterByName } from "../../../js_assets/getParameterByName";
import AppAdminContainer from "../AppAdminContainer";
import { CSVLink, CSVDownload } from "react-csv";
import CanvasJSReact from "../../../../canvasjs.react";
import moment from "moment";
import { osName } from "react-device-detect";
import Table from "./Table";
import LoadingIcon from "../../LoadingIcon";
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
// import "./node_modules/ag-grid-community/dist/styles/ag-grid.css";
// import "./node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
const SubsCounts = () => {
  const [gridApi, setGridApi] = useState(null);
  const [Admin_Info, setAdmin_Info] = useState(
    JSON.parse(localStorage.getItem("Admin_Info"))
  );

  const [rowData, setRowData] = useState([]);
  const [drowData, setDRowData] = useState([]);
  const [trowData, setTRowData] = useState([]);
  const [rateData, setTRateData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);

  const [duplication, setDuplication] = useState(false);
  const [times, setTimes] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rate, setRate] = useState(false);
  const [payment, setPayment] = useState(false);

  const headers = [
    { label: "اسم المستخدم", key: "userName" },
    { label: "رقم الجوال", key: "user_Phone" },
    { label: "الايميل", key: "user_Email" },
    { label: "الجدول المراد", key: "followUp_Schedule_Name" },
    { label: "اسم المدرب ", key: "trainer_Name" },
    { label: "التاريخ ", key: "attempt_Payment_Subscription_Datetime" },
  ]

  const rateHeaders = [
    { label: "اسم المدرب", key: "trainer_Name" },
    { label: "نوع الجدول", key: "followUp_Schedule_Name" },
    { label: "اسم المشرك", key: "userName" },
    { label: "رقم الجوال", key: "user_Phone" },
    { label: "ايميل المشرك", key: "user_Email" },
    { label: "تاريخ التقييم ", key: "subscription_Survey_DateTime" },
  ]

  const headCellsForRowData = [
    {
      key: "userId",
      label: "رمز المستتخدم",
    },
    {
      key: "userName",
      label: "اسم المستتخدم",
    },

    {
      key: "user_Phone",
      label: "رقم الجوال",
    },
    {
      key: "subscription_Price",
      label: "قيمة الاشتراك",
    },
    {
      key: "trainer_Name",
      label: " اسم المدرب",
    },
    {
      key: "المدة",
      label: "المدة"
    },
    {
      key: "subscription_Date",
      label: "بداية الاشتراك",
    },
    {
      key: "subscription_End",
      label: "نهاية الاشتراك",
    },
  ];
  const csvReport = {
    filename: 'Report.csv',
    headers: headers,
    data: paymentData

  }

  const drowDataReport = {
    filename: 'drowData.csv',
    headers: headCellsForRowData,
    data: drowData

  }

  const rateDataReport = {
    filename: 'rateData.csv',
    headers: rateHeaders,
    data: rateData

  }


  const trowDataReport = {
    filename: 'trowData.csv',
    headers: headCellsForRowData,
    data: trowData

  }






  function Delete_Survey(ID) {
    setLoading(true)
    GetApi(
      `/api/Admin/Delete_Survey_Trainer/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      setLoading(false)

      alert("تم الحدف");
    });
  }
  useEffect(() => {
    setLoading(true)

    GetApi(
      `/api/Admin/Get_All_Subscription_Schedule/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      let arra = [];
      arra = rep.result;
      let count = {};
      //   arra.forEach(function (i) {
      //     count[i.userId] = (count[i.userId] || 0) + 1;
      //     arra[i].push(count);
      //   });
      //   let c = 0;
      //   let i = 0;
      //   let j = 0;
      //   for (i; i < arra.length; i++) {
      //     for (j; j < arra.length; j++) {
      //       if (arra[i].userId === arra[j].userId) {
      //         c = c + 1;
      //         console.log("count", c);
      //         //   console.log("arra", arra[i]);
      //       }
      //     }
      //     count = { c };
      //     arra.push(count);
      //   }

      //   console.log("count", count);

      let duplicateIds = arra
        .map((e) => e["userId"])
        .map((e, i, final) => final.indexOf(e) !== i && i)
        .filter((obj) => arra[obj])
        .map((e) => arra[e]["userId"]);
      let duplicate = arra.filter((obj) => duplicateIds.includes(obj.userId));
      console.log("arra", duplicate);
      let result = arra.filter(
        (e) =>
          moment(e.subscription_End).diff(moment(e.subscription_Date), "days") >
          31
      );

      setTRowData(result);
      setDRowData(duplicate);
      setRowData(arra);
      setLoading(false)

    });
  }, []);
  useEffect(() => {
    setLoading(true)

    PostApi(
      `/api/Admin/Get_Subscription_Survey/${Admin_Info.admin_Id}`,
      Admin_Info.admin_Id,
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      setTRateData(rep.result.reverse());
      setLoading(false)

    });
  }, []);
  useEffect(() => {
    setLoading(true)

    PostApi(
      `/api/Admin/Get_Attempt_Payment_Subscription/${Admin_Info.admin_Id}`,
      Admin_Info.admin_Id,
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      setPaymentData(rep.result);
      setLoading(false)

    });
  }, []);

  if (loading) {
    return (
      <div style={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center" }}>

        <LoadingIcon />
      </div>
    )
  }
  if (duplication) {
    return (
      <AppAdminContainer Title={"الجداول"}>
        <div>
          <div
            style={{
              marginTop: "7%",
              alignItems: "center",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,

                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setDuplication(!duplication);
                setTimes(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من اشتراك
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(!times);
                setDuplication(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من شهر
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(!rate);
                setPayment(false);
              }}
            >
              التقييم
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(false);
                setPayment(!payment);
              }}
            >
              الدفع
            </button>
          </div>


          <button style={{ marginBottom: 10, marginTop: 10, backgroundColor: "green" }}><CSVLink {...drowDataReport}>تحميل اكسل اكثر من اشتراك </CSVLink></button>
          <table
            style={{
              textAlign: "center",
              //   fontFamily: "Trebuchet MS", Arial, Helvetica, sans-serif;
              borderCollapse: "collapse",
              border: "3px solid #ddd",
              width: "98%",
              marginRight: 15,
            }}
          >
            <tbody>
              <tr>
                {" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الرمز{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاسم{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                    position: "sticky",
                  }}
                >
                  {" "}
                  الجوال{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاجمالي{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  اسم المدرب{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  المدة{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  بداية الاشتراك{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  نهاية الاشتراك{" "}
                </th>{" "}
              </tr>

              {drowData.map((e, i) => {
                return (
                  <tr key={i}>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userId}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userName}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.user_Phone}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.subscription_Price}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.trainer_Name}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).diff(
                        moment(e.subscription_Date),
                        "days"
                      )}{" "}
                      يوم{" "}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_Date).format("YYYY-MM-DD")}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).format("YYYY-MM-DD")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </AppAdminContainer>
    );
  }
  if (times) {
    return (
      <AppAdminContainer Title={"الاحصائيات"}>
        <div>
          <div
            style={{
              marginTop: "7%",
              alignItems: "center",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setDuplication(!duplication);
                setTimes(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من اشتراك
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(!times);
                setDuplication(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من شهر
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(!rate);
                setPayment(false);
              }}
            >
              التقييم
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(false);
                setPayment(!payment);
              }}
            >
              الدفع
            </button>
          </div>
          <table
            style={{
              textAlign: "center",
              //   fontFamily: "Trebuchet MS", Arial, Helvetica, sans-serif;
              borderCollapse: "collapse",
              border: "3px solid #ddd",
              width: "98%",
              marginRight: 15,
            }}
          >

            <button style={{ marginBottom: 10, marginTop: 10, backgroundColor: "green" }}><CSVLink {...trowDataReport}>تحميل اكسل اكثر من شهر </CSVLink></button>
            <tbody>
              <tr>
                {" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الرمز{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاسم{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                    position: "sticky",
                  }}
                >
                  {" "}
                  الجوال{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاجمالي{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  اسم المدرب{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  المدة{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  بداية الاشتراك{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  نهاية الاشتراك{" "}
                </th>{" "}
              </tr>

              {trowData.map((e, i) => {
                return (
                  <tr key={i}>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userId}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userName}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.user_Phone}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.subscription_Price}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.trainer_Name}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).diff(
                        moment(e.subscription_Date),
                        "days"
                      )}{" "}
                      يوم{" "}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_Date).format("YYYY-MM-DD")}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).format("YYYY-MM-DD")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </AppAdminContainer>
    );
  }
  if (rate) {
    return (
      <AppAdminContainer Title={"الاحصائيات"}>
        <div>
          <div
            style={{
              marginTop: "7%",
              alignItems: "center",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setDuplication(!duplication);
                setTimes(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من اشتراك
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(!times);
                setDuplication(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من شهر
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(!rate);
                setPayment(false);
              }}
            >
              التقييم
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(false);
                setPayment(!payment);
              }}
            >
              الدفع
            </button>
          </div>

          <button style={{ marginBottom: 10, marginTop: 10, backgroundColor: "green" }}><CSVLink {...rateDataReport}>تحميل اكسل التقيم </CSVLink></button>
          {rateData.map((e) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    boxShadow: " 5px 10px 18px #888888",

                    backgroundColor: "#b1d236",
                    padding: 10,

                    borderRadius: 15,
                  }}
                >
                  <div
                    style={{
                      width: "28%",
                      height: 380,
                      borderLeftStyle: "solid",
                      borderWidth: 10,
                      borderColor: "#b1d236",
                      padding: 10,
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>اسم المدرب :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {" "}
                        {e.trainer_Name}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>نوع الجدول :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {e.followUp_Schedule_Name}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>اسم المشرك :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {" "}
                        {e.userName}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>رقم الجوال :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {" "}
                        {e.user_Phone}
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>ايميل المشرك :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {" "}
                        {e.user_Email}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div>تاريخ التقييم :</div>
                      <div style={{ color: "#b1d236", paddingRight: 5 }}>
                        {" "}
                        {moment(e.subscription_Survey_DateTime).format(
                          "YYYY-MM-DD"
                        )}
                      </div>

                    </div>
                    <div style={{ width: 100, height: 30, backgroundColor: "red", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: 5, marginTop: 5, marginRight: 7 }}
                      onClick={() => {
                        if (window.confirm("هل متاكد انك تبغى تحدف  ؟؟"))
                          Delete_Survey(e.subscription_survey_Id);
                      }}
                    >
                      حذف
                    </div>
                  </div>
                  <div
                    style={{
                      width: "72%",
                      height: 380,

                      padding: 10,
                      backgroundColor: "white",
                    }}
                  >
                    <span>
                      {JSON.parse(e.subscription_Survey_Result).map((e) => {
                        return (
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div>{e.q}</div>
                            <div style={{ color: "#b1d236", paddingRight: 5 }}>
                              {" "}
                              {e.a}{" "}
                            </div>
                          </div>
                        );
                      })}{" "}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </AppAdminContainer >
    );
  }
  if (payment) {
    return (
      <AppAdminContainer Title={"الاحصائيات"}>
        <div>
          <div
            style={{
              marginTop: "7%",
              alignItems: "center",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setDuplication(!duplication);
                setTimes(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من اشتراك
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(!times);
                setDuplication(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من شهر
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(!rate);
                setPayment(false);
              }}
            >
              التقييم
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(false);
                setPayment(!payment);
              }}
            >
              الدفع
            </button>
          </div>

          <button style={{ marginBottom: 10, marginTop: 10, backgroundColor: "green" }}><CSVLink {...csvReport}>تحميل اكسل الدفع </CSVLink></button>
          {paymentData.map((e) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "97%",
                    boxShadow: " 5px 10px 18px #888888",
                    height: 120,
                    backgroundColor: "white",
                    borderColor: "#b1d236",
                    borderWidth: 4,
                    padding: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    borderStyle: "solid",
                    borderRadius: 15,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>اسم المسخدم :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {e.userName}
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>رقم الجوال :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {" "}
                      {e.user_Phone}
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>ايميل المشرك :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {" "}
                      {e.user_Email}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div> الجدول المراد :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {" "}
                      {e.followUp_Schedule_Name}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div> اسم المدرب :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {" "}
                      {e.trainer_Name}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div> التاريخ :</div>
                    <div
                      style={{
                        color: "#b1d236",
                        paddingRight: 5,
                        paddingLeft: 9,
                      }}
                    >
                      {" "}
                      {moment(e.attempt_Payment_Subscription_Datetime).format(
                        " hh:mm YY-MM-DD "
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </AppAdminContainer>
    );
  } else {
    return (
      <AppAdminContainer Title={"الاحصائيات"}>
        <div>
          <div
            style={{
              marginTop: "7%",
              alignItems: "center",
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setDuplication(!duplication);
                setTimes(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من اشتراك
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(!times);
                setDuplication(false);
                setRate(false);
                setPayment(false);
              }}
            >
              اكثر من شهر
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(!rate);
                setPayment(false);
              }}
            >
              التقييم
            </button>
            <button
              style={{
                height: 50,
                width: 150,
                backgroundColor: "#b1d236",
                color: "white",
                marginRight: 18,
                fontSize: 15,
                font: "inherit",
              }}
              onClick={() => {
                setTimes(false);
                setDuplication(false);
                setRate(false);
                setPayment(!payment);
              }}
            >
              الدفع
            </button>
          </div>
          sdgdfgfdg
          <table
            style={{
              textAlign: "center",
              // fontFamily: "Trebuchet MS, Arial, Helvetica, sans-serif",
              borderCollapse: "collapse",
              border: "3px solid #ddd",
              width: "98%",
              marginRight: 15,
            }}
          >
            <tbody>
              <tr>
                {" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الرمز{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاسم{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                    position: "sticky",
                  }}
                >
                  {" "}
                  الجوال{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  الاجمالي{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  اسم المدرب{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  المدة{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  بداية الاشتراك{" "}
                </th>{" "}
                <th
                  style={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                    backgroundColor: "#b1d236",
                    color: "white",
                  }}
                >
                  {" "}
                  نهاية الاشتراك{" "}
                </th>{" "}
              </tr>

              {rowData.map((e, i) => {
                return (
                  <tr key={i}>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userId}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.userName}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.user_Phone}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.subscription_Price}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {e.trainer_Name}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).diff(
                        moment(e.subscription_Date),
                        "days"
                      )}{" "}
                      يوم{" "}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_Date).format("YYYY-MM-DD")}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {moment(e.subscription_End).format("YYYY-MM-DD")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </AppAdminContainer>
    );
  }
};

export default SubsCounts;
